<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="100" class="search-form">
              <Form-item label="任务名称" prop="taskName">
                <Input type="text" v-model="searchForm.taskName" placeholder="请输入任务名称" clearable style="width: 200px"/>
              </Form-item>
              <!-- <Form-item label="监测关键词" prop="keywords">
                <Input type="text" v-model="searchForm.keywords" placeholder="请输入监测关键词" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
                <Form-item label="监测平台" prop="mediaPlatform">
                  <Input type="text" v-model="searchForm.mediaPlatform" placeholder="请输入监测平台" clearable style="width: 200px"/>
                </Form-item> -->
                <!-- <Form-item label="监测任务状态" prop="monitorStatus">
                  <Input type="text" v-model="searchForm.monitorStatus" placeholder="请输入监测任务状态" clearable style="width: 200px"/>
                </Form-item> -->
                <Form-item label="版权" prop="copyrightName"> 
                  <Select :label-in-value="true" @on-change="copyTypeChange" v-model="searchForm.copyrightMyType" placeholder="请选择" style="width: 200px;margin-left:20px;">
                    <Option v-for="(item, i) in dictTime" :key="i" :value="item.id">{{item.copyright_name}}</Option>
                  </Select>
                </Form-item>
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <!-- <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a> -->
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table @on-row-click="goJump" :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >        <FormItem label="任务名称" prop="taskName" >
          <Input v-model="form.taskName" style="width:100%"/>
        </FormItem>
        <FormItem label="监测关键词" prop="keywords" >
          <Input v-model="form.keywords" style="width:100%"/>
        </FormItem>
        <FormItem label="监测平台" prop="mediaPlatform" >
          <Input disabled="disabled" v-model="form.mediaPlatform" style="width:100%"/>
        </FormItem>
        <!-- <FormItem label="侵权发现数量" prop="tortNum" >
          <Input v-model="form.tortNum" style="width:100%"/>
        </FormItem> -->
        <!-- <FormItem label="监测任务状态" prop="monitorStatus" >
          <Input v-model="form.monitorStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="监测任务组ID" prop="groupId" >
          <Input v-model="form.groupId" style="width:100%"/>
        </FormItem>
        <FormItem label="时间单位 1分 2小时 3天 4 月" prop="timeUnit" >
          <Input v-model="form.timeUnit" style="width:100%"/>
        </FormItem>
        <FormItem label="时间间隔" prop="timeInterval" >
          <Input v-model="form.timeInterval" style="width:100%"/>
        </FormItem> -->
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "monitor-copyright-task-manage",
  components: {
  },
  data() {
    return {
      dictTime:[{
        copyright_name: "全部",
        id:"alls",
        value:"alls",
      }],
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      copyrightName:'',
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "createTime", // 默认排序字段
        order: "desc", // 默认排序方式
        copyrightMyType:'alls',
      },
      form: { // 添加或编辑表单对象初始化数据
        taskName: "",
        keywords: "",
        mediaPlatform: "全平台",
        tortNum: "",
        monitorStatus: "",
        groupId: "",
        timeUnit: "",
        timeInterval: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "任务名称",
          key: "taskName",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "监测关键词",
          key: "keywords",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "监测平台",
          key: "mediaPlatform",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "侵权发现数量",
          key: "tortNum",
          minWidth: 120,
          sortable: false,
        },
        // {
        //   title: "监测任务状态",
        //   key: "monitorStatus",
        //   minWidth: 120,
        //   sortable: false,
        // },
        // {
        //   title: "监测任务组ID",
        //   key: "groupId",
        //   minWidth: 120,
        //   sortable: false,
        // },
        // {
        //   title: "时间单位 1分 2小时 3天 4 月",
        //   key: "timeUnit",
        //   minWidth: 120,
        //   sortable: false,
        // },
        // {
        //   title: "时间间隔",
        //   key: "timeInterval",
        //   minWidth: 120,
        //   sortable: false,
        // },
        {
          title: "操作",
          key: "action",
          align: "center",
          minWidth: 200,
          render: (h, params) => {
            return h("div",{
              style: {
                display: 'flex',
                justifyContent: 'center',
                flexDirection:'row',
                alignItems: 'center',
              },
            },[
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginTop: "5px",
                    marginBottom: "5px",
                    width:'100px',
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation();
                      this.edit(params.row);
                    }
                  }
                },
                "编辑"
              ),
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "error",
              //       size: "small",
              //       icon: "md-trash"
              //     },
              //     style: {
              //       marginBottom: "5px",
              //       width:'100px',
              //     },
              //     on: {
              //       click: () => {
              //         this.remove(params.row);
              //       }
              //     }
              //   },
              //   "删除"
              // ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    icon: "ios-add"
                  },
                  style: {
                    marginLeft: "15px",
                    width:'100px',
                  },
                  on: {
                    click: (e) => {
                      e.stopPropagation();
                      this.goTask(params.row);
                    }
                  }
                },
                "执行任务"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    // 获取任务的列表的数据
    getTaskList(){
      this.dictTime = [{
        copyright_name: "全部",
        id:"alls",
        value:"alls",
      }]
      this.postRequest("/videoclip/monitor/monitorCopyrightTask/getCopyrightList", {}).then(res => {
        let results = res
          for(let i of results){
            i.value = i.id
          }
        this.dictTime = this.dictTime.concat(res)
      });
    },
    // 跳转到下一页面
    goJump(v){
      console.log('++++++++++++++++++++++++',v)
      let query = { id:v.id };
      this.$router.push({
          name: "tort-copyright-report",//授权页面
          query: query
      });
    },
    copyTypeChange(v){
        if(v.label.trim()=='全部'){
          this.copyrightName = ''
        }else{
          this.copyrightName = v.label.trim()
        }
        this.getDataList()
    },
    init() {
      this.getDataList();
      this.getTaskList();
      if(this.$route.query.id){
        this.myDefineInit();
      }
    },
    myDefineInit(){
      // this.form.copyrightName = this.copyrightName
      let params = {
        copyrightId:this.$route.query.id,
        taskName:this.$route.query.name+'-监测任务',
        mediaPlatform:'全平台',
        keywords:this.$route.query.name,
        copyrightName:this.$route.query.name
      }
      this.postRequest("/videoclip/monitor/monitorCopyrightTask/insertOrUpdate", params).then(res => {
        if (res.success) {
          this.$Message.success("操作成功");
          this.getDataList()
        }else{
          this.$Message.error(res.message);
          this.getDataList()
        }
      });
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      this.searchForm.copyrightName = this.copyrightName
      this.getRequest("/videoclip/monitor/monitorCopyrightTask/getByPage", this.searchForm).then(res => {
        this.loading = false;
        if (res.success) {
          let array = res.result.records
          for(let i of array){
            i.mediaPlatform = '全平台'
            switch(i.monitorStatus){
              case 0:
                i.monitorStatus = '停止'
                break;
              case 1:
                i.monitorStatus = '运行'
                break;
              case 2:
                i.monitorStatus = '完成'
                break;
              default:
                break;
            }
          }
          this.data = res.result.records;
          this.total = res.result.total;
        }
      });
      // 以下为模拟数据
      //this.data = [
      //];
      this.total = this.data.length;
      this.loading = false;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            this.form.copyrightName = this.copyrightName
            this.postRequest("/videoclip/monitor/monitorCopyrightTask/insertOrUpdate", this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
            });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          } else {
            // 编辑
            this.form.copyrightName = this.copyrightName
            this.postRequest("/videoclip/monitor/monitorCopyrightTask/insertOrUpdate", this.form).then(res => {
              this.submitLoading = false;
              if (res.success) {
                this.$Message.success("操作成功");
                this.getDataList();
                this.modalVisible = false;
              }
            });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    // 执行任务接口
    goTask(v){
      console.log('+++++++++++++++++++++++++++++++++',v)
      let params = {
        copyrightId:v.copyrightId,
        keyWords:v.keywords,
        taskId:v.id,
      }
      this.postRequest("/videoclip/monitor/monitorCopyrightTask/executeJob", params).then(res => {
        this.submitLoading = false;
        if (res.success) {
          this.$Message.success("操作成功");
          this.getDataList();
          this.modalVisible = false;
        }
      });
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.taskName + " ?",
        loading: true,
        onOk: () => {
          // 删除
          this.deleteRequest("/videoclip/monitor/monitorCopyrightTask/delByIds/" + v.id).then(res => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.getDataList();
            }
          });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          this.deleteRequest("/videoclip/monitor/monitorCopyrightTask/delByIds/" + ids).then(res => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.clearSelectAll();
              this.getDataList();
            }
          });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>